import React, { useEffect, useState } from 'react';
import GoogleFixedAds from '../googleAds/GoogleFixedads';
import './FullScreenAd.css';
import { GOOGLE_ADS_CLIENT } from '../../lib/config';
const FullScreenAd = ({ isOpen, onClose }) => {
  const [canClose, setCanClose] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (isOpen) {
      // Prevent closing immediately
      setCanClose(false);
      setCountdown(8);
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';

      // Countdown timer
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            setCanClose(true);
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearInterval(timer);
        document.body.style.overflow = '';
      };
    }
  }, [isOpen]);

  const handleClose = () => {
    if (canClose) {
      // Track ad view
      if (window.gtag && window.cookieConsentGiven) {
        window.gtag('event', 'fullscreen_ad_closed', {
          event_category: 'Ad Engagement',
          event_label: 'Full Screen Ad Closed',
          value: 1
        });
      }
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fullscreen-ad-overlay" onClick={canClose ? handleClose : undefined}>
      <div className="fullscreen-ad-container" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          className={`fullscreen-ad-close ${canClose ? 'enabled' : 'disabled'}`}
          onClick={handleClose}
          disabled={!canClose}
          aria-label="Close ad"
        >
          {canClose ? '×' : countdown}
        </button>

        {/* Ad Label */}
        {/* <div className="fullscreen-ad-label">Advertisement</div> */}

        {/* Ad Content - Using your ad slot ID 5433407966 */}
        <div className="fullscreen-ad-content">
          <GoogleFixedAds
            style={{ 
              display: 'block', 
              width: '100%', 
              height: '100%',
              minHeight: '250px'
            }}
            client={GOOGLE_ADS_CLIENT}
            slot="5433407966"
            format="auto"
            fullWidthResponsive={true}
          />
        </div>

        {/* Skip Button (appears when countdown ends) */}
        {canClose && (
          <button className="fullscreen-ad-skip" onClick={handleClose}>
            Continue to Video
          </button>
        )}
      </div>
    </div>
  );
};

export default FullScreenAd;

